export const COMPANY = {
  name: "Aad Labs (OPC) Private Limited",
  short: "Aad Labs",
  tagline: "Your Trusted Bridge from Indian Manufacturing Excellence to Global Markets",
  director: "Aaditya Singh",
  gstin: "06ABECA7749J1ZB",
  iec: "ABECA7749J",
  fssai: "10826999000493",
  pan: "ABECA7749J",
  established: "2026",
  address:
    "3rd Floor, Plot No. 948, Maharishi Parashar Marg, Sector 15, Faridabad, Haryana - 121007, India",
  email: "contact@aadlabsglobal.com",
  phone: "+91 97170 07794",
  phoneRaw: "919717007794",
};

export const BROCHURE_URL = `/aad-labs-dossier.pdf`;
// Static catalogue PDF — same source dossier the user uploaded
export const CATALOGUE_URL = `/aad-labs-dossier.pdf`;

export const CERTIFICATIONS = [
  "WHO-GMP Certified",
  "ISO 22000:2018",
  "FDCA (Gujarat)",
  "IAF Accredited",
  "FSSAI Certified",
  "Pharmexcil Member",
  "Make in India",
  "FDA Registered",
  "SHEFEXIL Member",
  "Star Export House",
  "USDA Organic",
  "India Organic",
  "Halal Certified",
  "Control Union",
  "GMP Certified",
  "Kosher Certified",
  "OneCert Organic",
  "HACCP Compliant",
];

export const IMAGES = {
  heroBg: "https://images.pexels.com/photos/13014206/pexels-photo-13014206.jpeg",
  lab: "https://images.pexels.com/photos/8940519/pexels-photo-8940519.jpeg",
  warehouse: "https://images.unsplash.com/photo-1684695749267-233af13276d0",
  turmeric: "https://images.pexels.com/photos/7988018/pexels-photo-7988018.jpeg",
  ginger: "https://images.pexels.com/photos/10899474/pexels-photo-10899474.jpeg",
  ashwagandha: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/wh6aheq4_ashagandha%20extract.png",
  spices: "https://images.pexels.com/photos/12809571/pexels-photo-12809571.jpeg",
  bacopa: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/90xhfx6h_Bacopa%20Extract%20%28Brahmi%29.png",
  rice: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/6mcfood6_ChatGPT%20Image%20Jul%2019%2C%202026%20at%2005_14_18%20PM.png",
  blackPepper: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/oih7ev3g_black%20pepper.png",
  cumin: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/uihv1ion_cumin.png",
  chilli: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/odwg69xm_chilli%20powder.png",
  driedChilli: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/5bn58zdm_dried%20chilli.png",
  cloves: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/li5lwl1g_cloves.png",
  flax: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/p949j6af_flax%20seeds.png",
  coriander: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/87jyr6br_coriander%20powder.png",
  raisins: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/4v9aidhe_green%20raisins.png",
  turmericPowder: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/prhrqqe8_turmeric%20powder.png",
};

export const BOTANICAL_EXTRACTS = [
  {
    slug: "ashwagandha",
    name: "Ashwagandha Extract",
    botanical: "Withania somnifera",
    tagline: "The King of Adaptogens — Clinically Standardized for Stress & Vitality",
    part: "Roots",
    active: "Withanolides",
    standardization: "0.25% – 15%",
    appearance: "Light Brown Powder",
    image: IMAGES.ashwagandha,
    description:
      "Ashwagandha, known in Sanskrit as the 'smell of a horse' for the strength it confers, is one of Ayurveda's most revered adaptogens. Our Ashwagandha Root Extract is standardized to Withanolides 0.25%–15% using HPLC and gravimetric methods, ensuring verified bioactive potency. Sourced from authenticated roots and processed under GMP-controlled conditions.",
    specs: [
      { k: "Botanical Name", v: "Withania somnifera" },
      { k: "Plant Part", v: "Roots" },
      { k: "Active Marker", v: "Withanolides" },
      { k: "Standardization", v: "0.25% – 15%" },
      { k: "Appearance", v: "Light Brown Powder" },
      { k: "Sieve Test", v: "100% pass through 40 mesh" },
      { k: "Heavy Metals", v: "NMT 10 ppm" },
      { k: "Microbial", v: "TPC NMT 5000 cfu/g; Pathogens Absent" },
    ],
    applications: "Stress management, sports nutrition, cognitive health, adaptogenic blends.",
    packaging: "1 kg, 5 kg, 25 kg food-grade HDPE drums with double-sealed liners.",
    benefits: ["Stress relief", "Adaptogenic", "Sports nutrition", "Cognitive health"],
  },
  {
    slug: "bacopa",
    name: "Bacopa Extract (Brahmi)",
    botanical: "Bacopa monnieri",
    tagline: "The Herb of Grace — Standardized Bacosides for Cognitive Excellence",
    part: "Herb (aerial parts)",
    active: "Bacosides",
    standardization: "10% – 50%",
    appearance: "Light Brown to Brown Powder",
    image: IMAGES.bacopa,
    description:
      "Bacopa monnieri, traditionally known as Brahmi, has been the cornerstone of Ayurvedic cognitive medicine for millennia. Our Bacopa Extract is standardized to Bacosides 10%–50% using HPLC, UV, and gravimetric analysis — delivering the precise bioactive load required for memory, focus, and neuroprotective formulations.",
    specs: [
      { k: "Botanical Name", v: "Bacopa monnieri" },
      { k: "Plant Part", v: "Herb (aerial parts)" },
      { k: "Active Marker", v: "Bacosides" },
      { k: "Standardization", v: "10% – 50%" },
      { k: "Appearance", v: "Light Brown to Brown Powder" },
      { k: "Sieve Test", v: "100% pass through 40 mesh" },
      { k: "Heavy Metals", v: "NMT 10 ppm total; Lead NMT 3 ppm" },
      { k: "Microbial", v: "Full USP <61> pathogen screening" },
    ],
    applications: "Nootropic supplements, memory support, ADHD formulations, cognitive health.",
    packaging: "1 kg, 5 kg, 25 kg food-grade HDPE drums.",
    benefits: ["Memory", "Cognitive function", "Nootropic", "Anxiety support"],
  },
  {
    slug: "ginger",
    name: "Ginger Extract",
    botanical: "Zingiber officinale",
    tagline: "Potent Anti-Inflammatory Support — Standardized to Gingerols",
    part: "Rhizome",
    active: "Gingerols",
    standardization: "0.1% – 5%",
    appearance: "Light Brown Dry Powder",
    image: IMAGES.ginger,
    description:
      "Ginger is among the world's most studied botanicals for digestive health, anti-nausea properties, and anti-inflammatory action. Our Ginger Rhizome Extract is standardized to Gingerols 0.1%–5% via HPLC, capturing the full therapeutic profile without the degradation common in poorly processed powders.",
    specs: [
      { k: "Botanical Name", v: "Zingiber officinale" },
      { k: "Plant Part", v: "Rhizome" },
      { k: "Active Marker", v: "Gingerols" },
      { k: "Standardization", v: "0.1% – 5%" },
      { k: "Appearance", v: "Light Brown Dry Powder" },
      { k: "Bulk Density", v: "0.3 – 0.5 g/ml" },
      { k: "Heavy Metals", v: "Compliant with USP <231>" },
      { k: "Microbial", v: "Full USP <61> pathogen screening" },
    ],
    applications: "Digestive health, anti-nausea, joint support, weight management, functional beverages.",
    packaging: "1 kg, 5 kg, 25 kg food-grade HDPE drums.",
    benefits: ["Digestive health", "Anti-nausea", "Anti-inflammatory", "Joint health"],
  },
  {
    slug: "turmeric",
    name: "Turmeric / Curcumin Extract",
    botanical: "Curcuma longa",
    tagline: "The Golden Standard — 95% Curcuminoids for Maximum Therapeutic Impact",
    part: "Rhizomes",
    active: "Curcuminoids",
    standardization: "5% – 95%",
    appearance: "Light Yellow to Yellow Powder",
    image: IMAGES.turmeric,
    description:
      "Curcumin, the bright yellow polyphenol that gives turmeric its legendary status, is one of the most researched natural compounds for anti-inflammatory and antioxidant activity. Our Turmeric Extract is standardized from 5% to 95% Curcuminoids using HPLC and UV methods — available in both water-soluble and water-insoluble forms. Manufactured from authenticated rhizomes under strict GMP controls, free from synthetic dyes and fillers.",
    specs: [
      { k: "Botanical Name", v: "Curcuma longa" },
      { k: "Plant Part", v: "Rhizomes" },
      { k: "Active Marker", v: "Curcuminoids" },
      { k: "Standardization", v: "5% – 95%" },
      { k: "Type", v: "Water Soluble & Water Insoluble" },
      { k: "Appearance", v: "Light Yellow to Yellow Powder" },
      { k: "Heavy Metals", v: "NMT 10 ppm total" },
      { k: "Microbial", v: "Salmonella, E. coli, S. aureus, P. aeruginosa — Absent" },
    ],
    applications: "Joint health, anti-inflammatory formulas, liver support, antioxidant blends, functional foods, cosmetics.",
    packaging: "1 kg, 5 kg, 25 kg food-grade HDPE drums with nitrogen flushing available.",
    benefits: ["Anti-inflammatory", "Antioxidant", "Joint health", "Liver support"],
  },
];

export const SPICES = [
  { name: "Black Pepper", image: IMAGES.blackPepper, description: "Whole and ground black pepper (Piper nigrum) sourced from the Malabar and Western Ghats regions. Bold, aromatic, high in piperine. Available in various mesh sizes and grades." },
  { name: "Cumin", image: IMAGES.cumin, description: "Premium Indian cumin seeds (Cuminum cyminum) — earthy, warm, essential for culinary and Ayurvedic applications. Machine-cleaned, sorted, and packed to export specifications." },
  { name: "Turmeric Powder", image: IMAGES.turmericPowder, description: "Bright, aromatic turmeric powder (Curcuma longa) with high curcumin content. Ideal for food, beverage, and cosmetic applications. Food-grade and cosmetic-grade available." },
  { name: "Coriander Powder", image: IMAGES.coriander, description: "Fresh, citrusy coriander powder (Coriandrum sativum) — finely ground from premium seeds. Consistent color, aroma, and particle size." },
  { name: "Chilli Powder", image: IMAGES.chilli, description: "Vibrant red chilli powder with controlled heat units (SHU). Sourced from Guntur and Byadgi regions. Mild, medium, and hot variants." },
  { name: "Cloves", image: IMAGES.cloves, description: "Whole and ground cloves (Syzygium aromaticum) — rich in eugenol, aromatic, meticulously hand-sorted for export quality." },
  { name: "Dried Chilli", image: IMAGES.driedChilli, description: "Whole dried red chillies (Byadgi, Guntur Sannam, Teja). Deep red color, uniform size, optimal moisture content." },
];

export const SEEDS = [
  { name: "Flax Seeds", image: IMAGES.flax, description: "Nutrient-dense flax seeds (Linum usitatissimum) — rich in omega-3 fatty acids and lignans. Cleaned, graded, and packed for nutritional supplement and food applications." },
  { name: "Green Raisins", image: IMAGES.raisins, description: "Premium green raisins — sweet, plump, naturally dried. Ideal for snacking, baking, and food processing." },
];

// Premium export seeds — high-margin, compliance-heavy specifications
export const PREMIUM_SEEDS = [
  {
    slug: "sesame-seeds",
    name: "Sesame Seeds",
    botanical: "Sesamum indicum",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/a15j40tb_ChatGPT%20Image%20Sep%2019%2C%202026%20at%2001_57_32%20PM.png",
    tagline: "Volume Supplier · Sortex-Cleaned · EU/US Compliant",
    intro:
      "India is the world's volume supplier for sesame seed. We source from Gujarat, Rajasthan, MP and West Bengal, delivering food-grade natural (unhulled) and premium hulled seed to tahini producers, bakery majors, snack manufacturers and oil crushers across four continents.",
    colors: [
      { name: "White / Cream", note: "Volume grade for tahini, bakery, snacks, and hulled applications" },
      { name: "Black", note: "Premium — Japan, China, Korea; Asian cuisine & superfood retail" },
      { name: "Brown / Golden / Red", note: "Oil crushing and regional cuisines" },
    ],
    forms: [
      "Natural (Unhulled) — cleaned raw seed",
      "Hulled (Dehulled) — white, higher value; tahini · halva · bakery",
      "Toasted / Roasted — value-added for foodservice & retail",
    ],
    grades: [
      { label: "Basic machine-cleaned", value: "99.0 – 99.5% purity" },
      { label: "Sortex-cleaned (Food-Grade Standard)", value: "99.9 – 99.95% purity" },
    ],
    specs: [
      { label: "Oil content", value: "48 – 52% (crusher & tahini spec)" },
      { label: "FFA (Free Fatty Acid)", value: "≤ 2.0% (typical export)" },
      { label: "Moisture", value: "≤ 6% (prevents mold & rancidity)" },
      { label: "Colour uniformity", value: "≥ 98% (hulled grade)" },
    ],
    compliance: [
      "Steam-sterilization available (EU / US / Australia Salmonella spec)",
      "Ethylene Oxide (EtO) — clear tests, EtO-free declaration",
      "Aflatoxin & pesticide residue reports on every lot",
      "Allergen-controlled facility (Sesame = major labelled allergen)",
      "Organic (India Organic · USDA · EU) available on order",
    ],
    packaging: "25 kg / 50 kg PP-woven or laminated bags · vacuum retail packs",
    moq: "1 × 20'FCL (typical)",
    lead: "20 – 28 days",
  },
  {
    slug: "psyllium-husk",
    name: "Psyllium Husk (Isabgol)",
    botanical: "Plantago ovata",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/opej2w8c_ChatGPT%20Image%20Sep%2019%2C%202026%20at%2002_05_01%20PM.png",
    tagline: "The Isabgol Belt · Sterilized · 98–99% Premium Grade",
    intro:
      "India — Gujarat & Rajasthan specifically — is the world's isabgol belt. We supply steam-sterilized 98–99% premium-grade husk and mesh-milled powders to nutraceutical majors, pharmaceutical formulators, and functional-food brands across the EU, US and Australia.",
    forms: [
      "Whole Seed — raw material and extraction",
      "Husk — the main product; supplements & food",
      "Husk Powder — 40 · 60 · 80 · 100 mesh (finer = better drink dispersion)",
    ],
    grades: [
      { label: "Feed / Price-driven grade", value: "85 – 90% purity" },
      { label: "Common food grade", value: "95% purity" },
      { label: "Premium supplement & pharma", value: "98 – 99% purity — whiter, cleaner, best swelling" },
    ],
    specs: [
      { label: "Swelling volume", value: "40 – 55 mL/g (functional quality marker)" },
      { label: "Moisture", value: "≤ 10%" },
      { label: "Foreign matter", value: "≤ 0.1% (premium grade)" },
      { label: "Colour", value: "Off-white to light cream (95%+ grade)" },
    ],
    compliance: [
      "Steam-sterilization standard for EU / US / Australia buyers",
      "Ethylene Oxide (EtO) — clear lab reports required for strict markets",
      "Heavy metals & pesticide residues within EU/USP compendial limits",
      "Organic (India Organic · USDA · EU) — commands premium",
      "Gluten-free · Non-GMO · Halal · Kosher on request",
    ],
    packaging: "25 kg PE-lined kraft bags · 500 kg jumbo bags · retail packs",
    moq: "500 kg (husk) · 1 × 20'FCL (bulk)",
    lead: "18 – 25 days",
  },
];

// Essential Oils — sixth product pillar
export const ESSENTIAL_OILS = [
  {
    slug: "spearmint-oil-organic",
    name: "Spearmint Oil",
    botanical: "Mentha spicata",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/pvvw898z_ChatGPT%20Image%20Sep%2019%2C%202026%20at%2002_12_45%20PM.png",
    origin: "India",
    certification: "Organic · ACO / USDA",
    method: "Steam distillation of fresh flowering herb",
    profile: "Sweet, minty, fresh — softer than peppermint",
    keyMarkers: "Carvone ≥ 55%",
    uses: "Chewing gum · toothpaste · confectionery · aromatherapy",
    packaging: "1 / 5 / 25 / 180 kg HDPE or aluminium drums",
    moq: "5 kg",
    lead: "10 – 15 days",
    premium: true,
  },
  {
    slug: "jasmine-sambac-absolute",
    name: "Jasmine Sambac Absolute",
    botanical: "Jasminum sambac",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/9tt587wa_ChatGPT%20Image%20Sep%2019%2C%202026%20at%2002_11_15%20PM.png",
    origin: "Tamil Nadu · Karnataka",
    certification: "Natural Absolute",
    method: "Solvent extraction from fresh flowers, hexane→ethanol",
    profile: "Rich, intensely floral, warm, honeyed — the queen of florals",
    keyMarkers: "Benzyl acetate · Linalool · Indole",
    uses: "Fine fragrance · perfumery · high-end skincare",
    packaging: "100 g / 500 g / 1 kg amber glass · 5 kg tinned",
    moq: "500 g",
    lead: "15 – 21 days",
    premium: true,
  },
  {
    slug: "palmarosa-oil",
    name: "Palmarosa Oil",
    botanical: "Cymbopogon martinii",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/05y3955h_ChatGPT%20Image%20Sep%2019%2C%202026%20at%2002_10_40%20PM.png",
    origin: "Uttar Pradesh · Madhya Pradesh",
    certification: "Natural · Food-grade grades available",
    method: "Steam distillation of dried grass",
    profile: "Sweet, rosy, floral-geranium — soft green undertone",
    keyMarkers: "Geraniol ≥ 75% · Geranyl acetate",
    uses: "Perfumery · soaps · cosmetics · mosquito-repellent formulations",
    packaging: "1 / 5 / 25 / 180 kg drums",
    moq: "5 kg",
    lead: "10 – 15 days",
  },
  {
    slug: "spikenard-oil",
    name: "Spikenard Oil",
    botanical: "Nardostachys jatamansi",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/zdsu2yt0_ChatGPT%20Image%20Sep%2019%2C%202026%20at%2002_09_36%20PM.png",
    origin: "Himalayan foothills (sustainable-harvest)",
    certification: "Wild-harvested · CITES-compliant",
    method: "Steam distillation of dried rhizome",
    profile: "Earthy, woody, spicy, with musky-animalic depth",
    keyMarkers: "Valeranone · Jatamansone",
    uses: "Perfumery (chypre / oriental bases) · aromatherapy · Ayurveda",
    packaging: "100 g / 500 g / 1 kg amber glass · 5 kg tinned",
    moq: "1 kg",
    lead: "18 – 25 days",
    premium: true,
  },
  {
    slug: "juniperberry-oil",
    name: "Juniperberry Oil",
    botanical: "Juniperus communis",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/fd6h4d96_ChatGPT%20Image%20Sep%2019%2C%202026%20at%2002_08_58%20PM.png",
    origin: "India · imported EU berries also available",
    certification: "Natural · Food-grade grades available",
    method: "Steam distillation of dried berries",
    profile: "Fresh, pine-woody, peppery, slightly sweet-balsamic",
    keyMarkers: "α-Pinene · Myrcene · Sabinene",
    uses: "Gin flavouring · aromatherapy · perfumery · detoxification formulations",
    packaging: "1 / 5 / 25 kg drums",
    moq: "5 kg",
    lead: "12 – 18 days",
  },
  {
    slug: "peppermint-oil-organic",
    name: "Peppermint Oil",
    botanical: "Mentha piperita",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/gdvdtfxx_ChatGPT%20Image%20Sep%2019%2C%202026%20at%2002_05_08%20PM.png",
    origin: "Uttar Pradesh · Punjab",
    certification: "Organic · ACO / USDA · 100% Pure",
    method: "Steam distillation of fresh herb",
    profile: "Sharp, cool, intensely minty with menthol lift",
    keyMarkers: "Menthol ≥ 38% · Menthone",
    uses: "Confectionery · oral-care · pharmaceutical · aromatherapy",
    packaging: "1 / 5 / 25 / 180 kg drums",
    moq: "5 kg",
    lead: "10 – 15 days",
    premium: true,
  },
  {
    slug: "cornmint-oil",
    name: "Peppermint Cornmint Oil",
    botanical: "Mentha arvensis",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/42rit2s1_ChatGPT%20Image%20Sep%2019%2C%202026%20at%2002_08_00%20PM.png",
    origin: "Uttar Pradesh (world's largest producer)",
    certification: "Natural · Food-grade",
    method: "Steam distillation; dementholized fraction available",
    profile: "Strong, sharp minty — higher menthol than piperita",
    keyMarkers: "Menthol ≥ 45% (natural) · dementholized to spec",
    uses: "Cost-effective mint flavouring · toothpaste · balms · chewing gum",
    packaging: "5 / 25 / 180 kg drums",
    moq: "25 kg",
    lead: "10 – 15 days",
  },
  {
    slug: "black-pepper-oil",
    name: "Black Pepper Oil",
    botanical: "Piper nigrum",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/5o69ckxa_ChatGPT%20Image%20Sep%2019%2C%202026%20at%2002_05_36%20PM.png",
    origin: "Kerala · Karnataka",
    certification: "Natural · Food-grade",
    method: "Steam distillation of crushed dried peppercorns",
    profile: "Warm, spicy, woody with fresh peppery bite",
    keyMarkers: "β-Caryophyllene · Limonene · Sabinene",
    uses: "Fine fragrance · flavours · massage oils · aromatherapy",
    packaging: "1 / 5 / 25 kg drums",
    moq: "5 kg",
    lead: "12 – 18 days",
  },
  {
    slug: "lemongrass-oil-organic",
    name: "Lemongrass Oil",
    botanical: "Cymbopogon flexuosus",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/u2eauyh9_ChatGPT%20Image%20Sep%2019%2C%202026%20at%2002_07_04%20PM.png",
    origin: "Kerala · Northeast India",
    certification: "Organic · ACO / USDA · 100% Pure",
    method: "Steam distillation of fresh leaves",
    profile: "Bright, citrusy, sharp lemon — herbaceous undertone",
    keyMarkers: "Citral (Neral + Geranial) ≥ 75%",
    uses: "Perfumery · soaps · aromatherapy · insect repellents · flavour",
    packaging: "5 / 25 / 180 kg drums",
    moq: "5 kg",
    lead: "10 – 15 days",
    premium: true,
  },
  {
    slug: "spearmint-oil",
    name: "Spearmint Oil (Conventional)",
    botanical: "Mentha spicata",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/7h564ne9_ChatGPT%20Image%20Sep%2019%2C%202026%20at%2002_06_27%20PM.png",
    origin: "India",
    certification: "Natural · Food-grade",
    method: "Steam distillation of fresh flowering herb",
    profile: "Sweet, minty, softer than peppermint — refreshing",
    keyMarkers: "Carvone ≥ 55%",
    uses: "Chewing gum · toothpaste · confectionery",
    packaging: "1 / 5 / 25 / 180 kg drums",
    moq: "5 kg",
    lead: "10 – 15 days",
  },
];

export const GRAINS = [
  { name: "All Varieties of Rice", image: IMAGES.rice, description: "Comprehensive range of Indian rice: Basmati (1121, Pusa, Traditional, Sugandha), Non-Basmati (IR64, PR11, Sona Masoori, Ponni, Parmal), Brown rice, Parboiled, and Organic-certified options. Sourced from FSSAI-registered mills with full traceability." },
];

export const COFFEE_BEANS = [
  {
    slug: "arabica",
    name: "Arabica Coffee Beans",
    botanical: "Coffea arabica",
    tagline: "The Refined Cup — Sweet, Aromatic, Complex",
    origin: "Chikmagalur, Coorg & Baba Budangiri (Karnataka)",
    grade: "AAA · Screen 17/18 · Washed / Natural",
    processing: "Washed (fully wet), Natural (sun-dried), Honey process",
    roastProfile: "Medium — 210°C to 225°C for balanced acidity & sweetness",
    caffeine: "1.0 – 1.5%",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/zxfurrjq_arabica.png",
    description:
      "Arabica is the world's most cultivated and celebrated coffee species — responsible for roughly 60% of global production and virtually every specialty-grade coffee cupped above 80 SCA points. Our Indian Arabica is grown under the shade of native rainforest canopy in the Western Ghats at 900–1600 m elevation, hand-picked at peak cherry maturity, and processed at estate-level wet mills. The result: a bright, aromatic bean with the smooth acidity, floral top notes, and clean finish demanded by European roasters, Middle Eastern specialty houses, and Australian third-wave cafés.",
    specs: [
      { k: "Botanical Name", v: "Coffea arabica" },
      { k: "Origin", v: "Karnataka Western Ghats, India" },
      { k: "Bean Shape", v: "Oval, elongated, curved centre-cut" },
      { k: "Screen Size", v: "17/18 (AAA), 15/16 (AA)" },
      { k: "Moisture", v: "≤ 11% at loading" },
      { k: "Defect Count", v: "≤ 8 full-defects per 300 g (Grade 1)" },
      { k: "Caffeine", v: "1.0 – 1.5%" },
      { k: "Cupping Score", v: "82 – 86 SCA (specialty grade)" },
    ],
    cupping: "Floral aroma, medium-bright acidity, notes of milk chocolate, citrus zest, and jasmine. Clean lingering finish with a silky mouthfeel.",
    applications: "Specialty espresso blends, single-origin filter roasts, cold brew, premium capsule coffee, ready-to-drink beverages.",
    packaging: "60 kg jute bags with GrainPro liners · 30 kg vacuum bags for premium lots · Custom retail bag packing available.",
    benefits: ["Smooth acidity", "Complex aromatics", "Specialty grade", "Shade-grown"],
  },
  {
    slug: "robusta",
    name: "Robusta Coffee Beans",
    botanical: "Coffea canephora var. robusta",
    tagline: "The Bold Cup — Full Body, High Caffeine, Rich Crema",
    origin: "Wayanad, Chikmagalur & Coorg (Karnataka, Kerala)",
    grade: "AAA · Screen 18 · Washed / Natural / Kaapi Royale",
    processing: "Cherry (natural dry), Parchment (washed), Polished Kaapi Royale",
    roastProfile: "Medium-Dark to Dark — 225°C to 240°C for chocolatey depth",
    caffeine: "2.2 – 2.7%",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/jxuptai3_robusta.png",
    description:
      "Robusta is the workhorse of the global coffee industry — hardier than Arabica, higher in caffeine, and prized for the thick golden crema and full body it lends to espresso blends. India is the world's third-largest Robusta exporter, and Indian Kaapi Royale (polished Robusta) commands premium prices in Italy, Turkey, and the Gulf for its unique chocolate-earthy profile and clean cup. Grown at 500–1000 m under natural shade with intercropped spices, our Robusta is estate-processed, machine-cleaned, and colour-sorted to export-grade specifications.",
    specs: [
      { k: "Botanical Name", v: "Coffea canephora var. robusta" },
      { k: "Origin", v: "Karnataka & Kerala, Western Ghats, India" },
      { k: "Bean Shape", v: "Round, thick, straight centre-cut" },
      { k: "Screen Size", v: "18 (AAA), 17 (AA), 15 (A)" },
      { k: "Moisture", v: "≤ 11% at loading" },
      { k: "Defect Count", v: "≤ 15 full-defects per 300 g (Grade 1)" },
      { k: "Caffeine", v: "2.2 – 2.7%" },
      { k: "Broken Beans", v: "≤ 1.5% by weight" },
    ],
    cupping: "Deep aroma of dark chocolate, roasted nuts, and earthy tobacco. Full body, low acidity, heavy syrupy mouthfeel and a persistent bittersweet finish. Produces exceptional crema in espresso.",
    applications: "Espresso base blends (Italian & Turkish style), instant / spray-dried coffee, decaffeination stock, ready-to-drink beverages, private-label retail.",
    packaging: "60 kg jute bags with GrainPro liners · 25 kg PP-lined bags · Bulk container (FCL) 19,200 kg per 20-ft.",
    benefits: ["Full body", "Rich crema", "High caffeine", "Blend workhorse"],
  },
];

export const PACKAGING_CERTIFICATIONS = [
  {
    title: "Compostability & Biodegradation",
    subtitle: "Independently verified end-of-life performance across global compost streams.",
    items: [
      { short: "CPCB", full: "CPCB Certificate", detail: "Central Pollution Control Board (India) approval for compostable plastic alternatives." },
      { short: "ISO 17088", full: "CIPET ISO 17088", detail: "International compostable plastics standard, tested by CIPET." },
      { short: "EN 13432", full: "EN 13432", detail: "European standard for industrial composting of packaging." },
      { short: "AS 5810", full: "AS 5810", detail: "Australian standard certifying home-compostable performance." },
      { short: "ASTM D6400", full: "ASTM D6400", detail: "US standard for compostable plastics in municipal / commercial facilities." },
      { short: "ASTM D5511", full: "ASTM D5511", detail: "Verified anaerobic biodegradation under high-solids landfill conditions." },
    ],
  },
  {
    title: "Sustainable Sourcing",
    subtitle: "Traceable fibre from responsibly managed forests.",
    items: [
      { short: "FSC CoC", full: "FSC Chain of Custody", detail: "Forest Stewardship Council chain-of-custody certification for all paperboard inputs." },
    ],
  },
  {
    title: "Food Safety & Regulatory Approvals",
    subtitle: "Cleared for direct food contact across major export destinations.",
    items: [
      { short: "FSSAI", full: "FSSAI Food Safety", detail: "Food Safety and Standards Authority of India certification." },
      { short: "US FDA", full: "FDA Certificate", detail: "US Food & Drug Administration food-contact material clearance." },
      { short: "EU Food", full: "Food Safety (EU)", detail: "European Union framework compliance for food-contact packaging." },
      { short: "US Food", full: "Food Safety (US)", detail: "US food-contact safety certification for direct-contact applications." },
      { short: "Intl Food", full: "Food Safety (International)", detail: "Global food-contact conformance for cross-border food-service supply." },
      { short: "Migration", full: "Migration Test Report", detail: "Overall & specific migration analysis under EU 10/2011 protocols." },
      { short: "MW Migration", full: "Microwave Migration Report", detail: "Migration performance verified under microwave heating conditions." },
    ],
  },
  {
    title: "Quality Management & Ethical Compliance",
    subtitle: "Audited operations, transparent supply chain.",
    items: [
      { short: "BRC", full: "BRC Certificate", detail: "BRCGS Global Standard for consumer packaging safety and quality." },
      { short: "ISO 9001", full: "ISO 9001:2015", detail: "Certified quality management system across manufacturing operations." },
      { short: "SMETA 4-Pillar", full: "SMETA SEDEX 4-Pillar", detail: "Sedex ethical audit covering labour, health & safety, environment and business ethics." },
    ],
  },
];

export const PACKAGING = {
  intro:
    "A curated portfolio of compostable, food-grade paper packaging for the global hospitality and food-service industry — engineered for excellence, designed for the planet.",
  heroImage: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/utht8u2s_ChatGPT%20Image%20Jul%2028%2C%202026%20at%2002_16_38%20PM.png",
  categories: [
    {
      slug: "ripple-wall-cups",
      name: "Compostable Ripple Wall Cups",
      tagline: "Structural insulation meets tactile sophistication",
      image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/utht8u2s_ChatGPT%20Image%20Jul%2028%2C%202026%20at%2002_16_38%20PM.png",
      description:
        "Our signature ripple wall cups combine structural insulation with tactile sophistication. The vertical corrugated exterior provides superior heat protection while delivering a distinctive, premium hand-feel. Custom-printed designs available with 4-color precision printing.",
      sizes: ["8 oz", "12 oz", "16 oz", "20 oz"],
      finishes: ["Natural Kraft", "Matte Black", "Full-custom print"],
      useCase: "Premium coffee shops · hotel in-room dining · corporate catering.",
    },
    {
      slug: "double-wall-cups",
      name: "Compostable Double Wall Cups",
      tagline: "Engineered for optimal thermal performance",
      image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/5laajf1k_ChatGPT%20Image%20Jul%2028%2C%202026%20at%2002_18_10%20PM.png",
      description:
        "Dual-layer construction eliminates the need for cup sleeves while providing a flawless canvas for brand storytelling. Seamless finish, generous printable surface — ideal for high-volume roasteries and QSR chains.",
      sizes: ["7 oz", "8 oz", "12 oz", "16 oz", "20 oz"],
      finishes: ["Natural Kraft", "Fully custom printed"],
      useCase: "High-volume cafés · specialty roasteries · QSR chains.",
    },
    {
      slug: "embossed-collection",
      name: "Embossed Collection",
      tagline: "Where functionality becomes art",
      image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/p4sezsjn_ChatGPT%20Image%20Jul%2028%2C%202026%20at%2002_20_26%20PM.png",
      description:
        "Deep-relief embossing elevates the sensory experience while maintaining structural integrity for hot beverages. Includes standard double-wall embossed cups and Deep-Bottom Vending cups engineered for automated dispensing systems.",
      sizes: ["8 · 12 · 16 · 20 oz — Double-wall embossed", "12 oz — Deep-bottom vending"],
      finishes: ["Kraft embossed", "Custom relief plates (proprietary textures)"],
      useCase: "Luxury hotel minibars · premium vending operations · boutique cafés.",
    },
    {
      slug: "single-wall-solutions",
      name: "Single Wall Solutions",
      tagline: "Streamlined elegance without compromise",
      image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/g0f4d19w_ChatGPT%20Image%20Jul%2028%2C%202026%20at%2002_22_19%20PM.png",
      coldImage: "/packaging/cold-cups-grass.jpg",
      description:
        "Lightweight, compostable performance for both hot and cold applications. Two-side coated cold cups are condensation-resistant with superior liquid-barrier technology — perfect for iced beverages and juice bars.",
      sizes: ["Hot: 8 · 12 · 16 · 20 oz", "Cold: 12 · 16 · 20 oz (two-side coated)"],
      finishes: ["Kraft / White", "Two-side coated cold", "Full custom print"],
      useCase: "Event catering · fast-casual dining · juice bars · corporate events.",
    },
    {
      slug: "specialty-pint-cups",
      name: "Specialty & Pint Cups",
      tagline: "Purpose-built formats for regulated service",
      image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/yaadufhc_ChatGPT%20Image%20Jul%2028%2C%202026%20at%2002_24_38%20PM.png",
      partyImage: "/packaging/party-cups.jpg",
      description:
        "From celebratory gatherings to regulated beverage service. Party cups for events; pint cups with certified UK/CA measurement markings (M22 stamp) for licensed venues, pubs and stadiums.",
      sizes: ["Party: 16 oz (vibrant colours)", "Half Pint · Full Pint (regulated)", "American Pint (16 oz)"],
      finishes: ["Red · Blue vibrant prints", "Institutional white with M22 markings"],
      useCase: "Stadiums · festivals · pubs · outdoor events · hospitality venues.",
    },
    {
      slug: "lids-accessories",
      name: "Lids, Straws & Accessories",
      tagline: "Precision-engineered closures",
      image: "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/zvn0t9kc_ChatGPT%20Image%20Jul%2028%2C%202026%20at%2002_26_11%20PM.png",
      strawImage: "/packaging/paper-straws.jpg",
      psImage: "/packaging/ps-lids-lineup.jpg",
      description:
        "Fiber-based 90mm compostable paper lids, biopolymer 80/90mm sipper lids, PS Beaker/Fliplock/Sipper/Cold lids in Black/White/Green, and 4-ply custom-printed compostable paper straws — everything to complete the serving experience sustainably.",
      sizes: ["90 mm compostable paper lid", "80 / 90 mm compostable sipper lid", "PS Beaker / Fliplock / Sipper / Cold lids", "4-ply custom-printed paper straws"],
      finishes: ["Black · White · Green", "Full-custom print on straws"],
      useCase: "Complete cup-and-lid systems for takeaway operations.",
    },
  ],
  customExamples: [
    "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/p4sezsjn_ChatGPT%20Image%20Jul%2028%2C%202026%20at%2002_20_26%20PM.png",
    "https://customer-assets-0z36b82j.emergentagent.net/job_aad-labs-export/artifacts/g0f4d19w_ChatGPT%20Image%20Jul%2028%2C%202026%20at%2002_22_19%20PM.png",
  ],
};
